import type { Entry } from 'app/features/admin/modules/modules.model';
import type { Module } from 'app/features/admin/modules/modules.model';

export const NotificationFilterModeEnum = <const>{
  All: 'all',
  Messages: 'messages',
  Unread: 'unread',
};

export type NotificationFilterMode = (typeof NotificationFilterModeEnum)[keyof typeof NotificationFilterModeEnum];

export type NotificationLoadResult = 'loaded' | 'skipped' | 'error';

export const NOTIFICATION_COUNT_LIMIT = 99;

export const NotificationNavigationKindEnum = <const>{
  External: 'external',
  Internal: 'internal',
  Invalid: 'invalid',
  None: 'none',
};

export type NotificationNavigationTarget =
  | { kind: typeof NotificationNavigationKindEnum.External; url: string }
  | { kind: typeof NotificationNavigationKindEnum.Internal; url: string }
  | { kind: typeof NotificationNavigationKindEnum.Invalid }
  | { kind: typeof NotificationNavigationKindEnum.None };

export interface NotificationContent {
  archived: boolean;
  description?: string;
  entryId?: string;
  icon?: string;
  image?: string;
  link?: string;
  moduleId?: string;
  read: boolean;
  time?: string | Date;
  title?: string;
  useRouter?: boolean;
  user?: Entry;
}

export interface Notification extends Omit<Entry, 'entry'> {
  entry: NotificationContent;
  module?: Module;
}

export interface NotificationGroup {
  label: string;
  notifications: Notification[];
}
